var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isArrayValue
        ? [
            _c(
              "ul",
              { staticClass: "list-style m-0" },
              _vm._l(_vm.value, function (_val, _index) {
                return _c(
                  "li",
                  { key: `${_vm.parentKeyBind}-value-${_index}` },
                  [
                    _vm.isObject(_val)
                      ? [
                          _c(
                            "table",
                            _vm._l(_val, function (cValue, cProperty, cIndex) {
                              return _c(
                                "tr",
                                {
                                  key: `${_vm.parentKeyBind}-value-${_index}-child-${cIndex}`,
                                },
                                [
                                  _c("td", [_vm._v(_vm._s(cProperty))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(cValue))]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_val) +
                              "\n                "
                          ),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
          ]
        : _vm.isObjectValue
        ? [
            _c(
              "table",
              _vm._l(_vm.value, function (_val, _property, _index) {
                return _c(
                  "tr",
                  { key: `${_vm.parentKeyBind}-value-${_index}` },
                  [
                    _c("td", [_vm._v(_vm._s(_property))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_val))]),
                  ]
                )
              }),
              0
            ),
          ]
        : [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }